import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import MobileTabComponent from '../../common/components/MobileTabComponent';
export default class ForumMobileTabSessionItem extends MobileTabComponent {
  view() {
    return m(Button, {
      className: "Button Button--link",
      icon: this.attrs.definition.icon,
      onclick: () => app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
        user: app.session.user
      }).then(() => app.composer.show())
    }, this.attrs.definition.label);
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/ForumNewDiscussionItem', ForumMobileTabSessionItem);